import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDown } from "lucide-react";
import moment from "moment";

const FlagIT = () => (
  <svg width="24" height="16" viewBox="0 0 24 16" className="rounded-sm">
    <rect width="8" height="16" fill="#009246"/>
    <rect x="8" width="8" height="16" fill="#fff"/>
    <rect x="16" width="8" height="16" fill="#CE2B37"/>
  </svg>
);
const FlagGB = () => (
  <svg width="24" height="16" viewBox="0 0 24 16" className="rounded-sm">
    <rect width="24" height="16" fill="#012169"/>
    <path d="M0,0 L24,16 M24,0 L0,16" stroke="#fff" strokeWidth="3"/>
    <path d="M0,0 L24,16 M24,0 L0,16" stroke="#C8102E" strokeWidth="1.5"/>
    <path d="M12,0 V16 M0,8 H24" stroke="#fff" strokeWidth="5"/>
    <path d="M12,0 V16 M0,8 H24" stroke="#C8102E" strokeWidth="3"/>
  </svg>
);
const FlagFR = () => (
  <svg width="24" height="16" viewBox="0 0 24 16" className="rounded-sm">
    <rect width="8" height="16" fill="#002395"/>
    <rect x="8" width="8" height="16" fill="#fff"/>
    <rect x="16" width="8" height="16" fill="#ED2939"/>
  </svg>
);
const FlagES = () => (
  <svg width="24" height="16" viewBox="0 0 24 16" className="rounded-sm">
    <rect width="24" height="4" fill="#AA151B"/>
    <rect y="4" width="24" height="8" fill="#F1BF00"/>
    <rect y="12" width="24" height="4" fill="#AA151B"/>
  </svg>
);

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'it', name: 'Italiano', Flag: FlagIT },
    { code: 'en', name: 'English', Flag: FlagGB },
    { code: 'fr', name: 'Français', Flag: FlagFR },
    { code: 'es', name: 'Español', Flag: FlagES }
  ];

  const currentLang = languages.find(l => l.code === i18n.language) || languages[1];
  const CurrentFlag = currentLang.Flag;

  const changeLanguage = (code) => {
    i18n.changeLanguage(code);
    moment.locale(code);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition"
        data-testid="language-switcher"
      >
        <CurrentFlag />
        <ChevronDown size={14} className={`text-gray-500 transition ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} />
          <div className="absolute right-0 mt-2 w-44 bg-white rounded-lg shadow-lg border z-50">
            {languages.map((lang) => {
              const LangFlag = lang.Flag;
              return (
                <button
                  key={lang.code}
                  onClick={() => changeLanguage(lang.code)}
                  className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm hover:bg-gray-50 first:rounded-t-lg last:rounded-b-lg ${
                    i18n.language === lang.code ? 'bg-gray-100 font-medium' : ''
                  }`}
                  data-testid={`lang-${lang.code}`}
                >
                  <LangFlag />
                  <span>{lang.name}</span>
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSwitcher;
